var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.863 0c-3.308 0-6 2.692-6 6s2.692 6 6 6c3.309 0 6-2.692 6-6s-2.691-6-6-6Zm.39 9.562c-.086.014-.198.035-.32.058-.282.052-.619.115-.82.132-.243.02-.474-.12-.614-.32a.75.75 0 0 1-.09-.686l1.134-3.12h-1.18c0-.649.487-1.127 1.11-1.31.298-.088.852-.207 1.14-.19.173.012.474.12.614.32.141.2.175.457.091.687L7.184 8.252h1.179c0 .649-.47 1.203-1.11 1.31ZM6.864 3a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfoIcon);
export default ForwardRef;